import React, { useContext } from 'react'
import { Package, Users, Target, Eye } from 'lucide-react'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { getDevToolIcon } from '@/components/utils/taskCreationUtils'
import { RoadmapContext } from '@/context/RoadmapContext'
import CapacitySelect from '@/components/dashboard/roadmap/CapacitySelect'
import DevToolSelect, { DevTool } from '@/components/dashboard/roadmap/DevToolSelect'
import FeedbackFocusSelect from '@/components/dashboard/roadmap/FeedbackFocusSelect'
import { FeedbackFocus } from '@/hooks/useProductConfig'

interface RoadmapHeaderProps {
  selectedProductId: string
  onProductChange: (productId: string) => void
}

const RoadmapHeader = ({ selectedProductId, onProductChange }: RoadmapHeaderProps) => {
  const { products, selectedProduct, changeProductConfigs } = useContext(RoadmapContext)

  const getFeedbackFocusLabel = (value: string) => {
    const options = {
      '30days': 'Past 30 Days',
      '90days': 'Past 90 Days',
      year: 'Past Year',
      'all-time': 'All Time',
    }
    return options[value as keyof typeof options] || 'Past 90 Days'
  }

  const handleCapacityChange = (capacity: string) => {
    changeProductConfigs(selectedProduct.id, {
      ...selectedProduct.configs,
      capacity,
    })
  }

  const handleDevToolChange = (devTool: DevTool) => {
    changeProductConfigs(selectedProduct.id, {
      ...selectedProduct.configs,
      dev_tool: devTool,
    })
  }

  const handleFeedbackFocusChange = (feedbackFocus: FeedbackFocus) => {
    changeProductConfigs(selectedProduct.id, {
      ...selectedProduct.configs,
      feedback_focus: feedbackFocus,
    })
  }

  return (
    <div className="px-8 pb-8 pt-8 w-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <div className="flex flex-col gap-1.5">
            <Select value={selectedProductId} onValueChange={onProductChange}>
              <SelectTrigger className="w-fit min-w-[180px] bg-white text-base">
                <Package className="w-5 h-5 mr-2 text-[#FF4A8E]" />
                <SelectValue placeholder="Select product" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {products.map((product) => (
                    <SelectItem key={product.id} value={product.id}>
                      {product.name}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center self-end h-10 gap-4">
            <div className="w-48">
              <CapacitySelect
                value={selectedProduct.configs?.capacity || '3'}
                onChange={handleCapacityChange}
                showLabel={false}
              />
            </div>

            <div className="w-48">
              <DevToolSelect
                value={(selectedProduct.configs?.dev_tool as DevTool) || 'jira'}
                onChange={handleDevToolChange}
                showLabel={false}
              />
            </div>

            {/* <span className="mx-2 text-[#9F9EA1] dark:text-gray-400">・</span>

            <div className="flex items-center gap-1.5">
              <Target className="h-4 w-4 text-[#9F9EA1] dark:text-gray-400" />
              <span className="text-sm text-[#40424A] dark:text-gray-200">
                {selectedProduct.configs?.objectives?.length}{' '}
                {selectedProduct.configs?.objectives?.length === 1 ? 'Objective' : 'Objectives'} Selected
              </span>
            </div>

            <span className="mx-2 text-[#9F9EA1] dark:text-gray-400">・</span> */}

            <div className="w-48">
              <FeedbackFocusSelect
                value={(selectedProduct.configs?.feedback_focus as FeedbackFocus) || 'all-time'}
                onChange={handleFeedbackFocusChange}
                showLabel={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoadmapHeader
